import React from "react";
import translateString from "../utils/Locales";

let t = translateString;

export default class WaitDialog extends React.Component {

    constructor() {
        super();

        this.state = {
            waitingText: '',
        }
    }

    componentDidUpdate() {
        
    }

    handleText() {
        setTimeout(() => {
            if (this.state.waitingText.length === 3) {
                this.setState({ waitingText: '' });
            } else {
                this.setState({ waitingText: this.state.waitingText + '.' });
            }
            this.handleText();
        }, 200);
    }

    componentDidMount() {
        this.handleText();
    }

    render (){

        return ( 
            <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
                <div style={backView}>
                    <div style={mainClass}>
                        <div style={message} >{t('attendere_1')}{this.state.waitingText} {this.props.index ? this.props.index : ''}</div>
                    </div>
                </div>
            </div>
        )
    }

}

const backView = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const mainClass = {
    position: 'absolute',
    left: 'calc((100% - 300px)/2',
    top: 'calc((100% - 100px)/2)',
    height: '100px',
    right: '35%',
    minWidth: '300px',
    width: '300px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
    overflow: 'hidden',
}

const message = {
    textAlign: 'center',
    lineHeight: '60px',
    height: '100px',
    position: 'relative',  
}
